module.exports = __webpack_public_path__ + "static/img/icon-mask3.3b8920e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-mask3.png
// module id = p0uA
// module chunks = 0